import { BaseFileView } from './BaseFileView';
import type { ImportData } from '@/types/node';
import type { FileKind, NodeId, Web, Edit } from 'web';
import type { FlowGraph } from '../FlowGraph';

export class ImportView extends BaseFileView<ImportData> {
  constructor(graph: FlowGraph, nodeId: NodeId) {
    super(graph, nodeId);
  }

  getNodeData(): ImportData {
    return this.graph.store.getNodeData<ImportData>(this.nodeId);
  }

  getFilesList(): FileKind[] {
    return this.getNodeData().files;
  }

  protected wasmSetFiles(wasm: Web, files: FileKind[]): Edit {
    return wasm.setFiles(this.nodeId, files);
  }

  /**
   * Gets the currently selected file
   */
  getCurrentFile(): FileKind | null {
    const files = this.getFilesList();
    const selectedIndex = this.getSelectedIndex();
    return files[selectedIndex] ?? null;
  }

  setCameraLocked(locked: boolean) {
    this.graph.wasmEdit((wasm) => wasm.setCameraLocked(this.nodeId, locked));
  }
}
